
import { defineComponent, ref, reactive, onMounted } from 'vue'
import type { FormInstance, FormRules, Action } from "element-plus";
import { cycle } from "@/core/data/shared"

//services
import MasterService from '@/core/services/MasterService';
import acrdService from "@/core/services/AcrdService";
import { errManager, mbtoa } from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    name: "step-academic",
    props: {
        idacrd: {
            type: String,
            required: true,
            default: ""
        },
    },
    setup(props) {
        const { t } = useI18n();
        const loader = ref(false)
        const formRef = ref<FormInstance>()
        const form = reactive(<any>{})
        const rules = reactive<FormRules>({})
        const listCondition = ref<any>([])
        const listTypeMatricule = ref<any>([])
        const listPeriodos = ref<any>([2024, 2023])
        const listCycles = ref<any>(cycle)
        const setting = ref<any>([])

        const getSetting = async () => {
            loader.value = true
            try {
                const res1 = await MasterService.Details('api', mbtoa('CONDITION_ACADEMIC'))
                listCondition.value = res1.data

                const res2 = await MasterService.Details('api', mbtoa('TYPE_MATRICULE'))
                listTypeMatricule.value = res2.data

                if(props.idacrd){
                    //console.log('AQUI')
                    const res = await acrdService.getAcreditation(props.idacrd, 'show')
                    Object.assign(form, res.data.info)
                }
            } catch (error) {
                console.log((error as { response: any }).response)
                errManager((error as { response: any }).response)
            } finally {
                loader.value = false
            }

        }

        /*
        const getAcrd = async () => {
            loader.value = true
            await acrdService.getAcreditation(props.idacrd, 'show')
                .then((res) => {
                    Object.assign(form, res.data.info)
                    loader.value = false
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }
        */
        

        onMounted(() => {
            getSetting()
            //listCondition.value = props.conditionAcademic
            //listTypeMatricule.value = props.typeMatricule
            //if (props.idacrd)
            //    getAcrd()
        })

        return {
            t,
            loader,
            formRef,
            form,
            rules,
            listCondition,
            listTypeMatricule,
            listPeriodos,
            setting,
            listCycles,
            getSetting

        }

    },
})
